import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var UserSettingsSvg = function UserSettingsSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.57 3.878a4.706 4.706 0 0 1 8.032 3.325 4.703 4.703 0 0 1-4.704 4.704 4.706 4.706 0 0 1-4.705-4.704c0-1.247.495-2.443 1.378-3.325m3.328.112a3.215 3.215 0 0 0-2.273 5.486A3.215 3.215 0 0 0 13.17 4.93a3.22 3.22 0 0 0-2.272-.94",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.383 15.354a17 17 0 0 1 8.282-2.143v1.49c-2.59 0-5.028.631-7.174 1.749v1.418H8.8v1.49H2v-3.791z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.96 15.429a1.5 1.5 0 0 1 1.07-.458c.402 0 .787.165 1.07.458.284.292.444.69.444 1.104s-.16.811-.443 1.104a1.5 1.5 0 0 1-1.07.457 1.5 1.5 0 0 1-1.07-.457 1.59 1.59 0 0 1-.444-1.104c0-.414.16-.812.443-1.104m1.07.63a.45.45 0 0 0-.324.139.48.48 0 0 0 0 .67.45.45 0 0 0 .649 0 .48.48 0 0 0 0-.67.45.45 0 0 0-.325-.139",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.432 11.565h3.198v1.232q.39.179.736.44l1.035-.617 1.598 2.858-1.034.616q.045.439 0 .877l1.035.616-1.6 2.858-1.034-.616q-.345.26-.736.439V21.5h-3.198v-1.232a4 4 0 0 1-.737-.439l-1.034.616-1.599-2.857 1.034-.616a4.2 4.2 0 0 1 0-.878l-1.034-.616 1.6-2.858 1.034.617q.345-.26.736-.44zm1.054 1.088v.91l-.362.124c-.38.13-.73.338-1.027.613l-.284.263-.766-.456-.544.973.763.455-.078.385a3.1 3.1 0 0 0 0 1.225l.078.386-.763.455.544.973.765-.456.285.263c.298.275.647.483 1.027.612l.362.123v.91h1.089v-.91l.362-.123c.38-.129.73-.337 1.027-.613l.285-.263.765.457.545-.973-.765-.455.078-.385a3.1 3.1 0 0 0 0-1.226l-.078-.385.765-.456-.545-.973-.765.456-.285-.263a2.9 2.9 0 0 0-1.027-.612l-.362-.123v-.91z",
    clipRule: "evenodd"
  }));
};
export var UserSettings = function UserSettings(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: UserSettingsSvg
  }));
};